import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { JobService } from '@services/job.service';
import { MetaService } from '@services/meta.service';
import { NotificationComponent } from '@components/notification/notification.component';
import { FooterComponent } from '@components/footer/footer.component';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, NotificationComponent, FooterComponent]
})
export class AppComponent implements OnInit {
  private metaService = inject(MetaService);
  private readonly jobService = inject(JobService);
  private router = inject(Router);

  title = 'hr';

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      document.body.scrollTo(0, 0);
    });
  }
}
